class Utils {
	static formatPhone(input) {
		if (!input) {
			return;
		}
		
		switch (input.length) {
			case 7:
				return `${input.substring(0,3)}-${input.substring(3)}`;
			case 10:
				return `(${input.substring(0,3)}) ${input.substring(3,6)}-${input.substring(6)}`;
			default:
				return input;
		}
	}

	static sortBy(key, key2) {
		return (a,b) => {
			const keyA = a[key] || '';
			const keyB = b[key] || '';
			const key2A = a[key2] || '';
			const key2B = b[key2] || '';
			if (keyA < keyB)
				return -1;
			if (keyA > keyB)
				return 1;
			if (key2) {
				if (key2A < key2B)
					return -1;
				if (key2A > key2B)
					return 1;
			}
			return 0;
		}
	}
}

export default Utils;


// WEBPACK FOOTER //
// ./src/Utils.js